import { useAceptOrRejectPaymentRequest } from "@/apis/payments/hooks/usePostPaymentDecision"
import { useAppAlert } from "@/app/AppAlertProvider"
import { Button } from "@/app/common/components/Button"
import FormErrorMessage from "@/app/common/components/FormErrorMessage"
import { CheckCircleIcon, CloseIcon, InfoCircleIcon } from "@/app/common/icons/general"
import { parseRequestError } from "@/app/common/utilities"
import { SubmitButton } from "@/app/pages/family_application/student_details/shared/submit-button"
import { PaymentDetail } from "@/schemas/payments.schema"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/shad/ui/dialog"
import { Textarea } from "@/shad/ui/textarea"
import { useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { RejectPaymentSchema } from "./ReviewPaymentUI"
import { Card, CardContent } from "@/app/common/components/Card"

type Props = {
payment: PaymentDetail
onSuccess: () => void
}

export function ReviewMarketplaceOrder(props: Props) {
  const { payment, onSuccess } = props
    const {t} = useTranslation()
    const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false)
  const {fireAlert} = useAppAlert()
  const rejectFormMethods = useForm<RejectPaymentSchema>({
    defaultValues: {
      comment: '',
    },
  })


  const acceptPayment = useAceptOrRejectPaymentRequest({
    onSuccess: () => {
       fireAlert({
        variant: 'success',
         message: t('payment_approval_success'),
        title: true, 
        titleText: "Item Recieved"
       })
      onSuccess()
    } ,
    onError: (error) => {
      fireAlert({ variant: 'error', message: parseRequestError(error).message, title: false, });
    },
  });

  const rejectPayment = useAceptOrRejectPaymentRequest({
    onSuccess: () => {
      fireAlert({
        variant: 'error',
        message: t('reject_payment_success'),
        title: true,
        titleText: "Item Not Received"
      })
      onSuccess()
    },
    onError: (error) => { 
        fireAlert({ variant: 'error', message: parseRequestError(error).message, title: false, });
    },
  });
    function handleRejectPayment() { 
      rejectPayment.mutate({
        comment: rejectFormMethods.getValues().comment,
        decision: 'reject',
        payment_id: payment.payment_id,
        program_id: payment.program_id,
      })
    }

    function handleRecievedItemClick() { 
      acceptPayment.mutate({
        comment: '',
        decision: 'accept',
        payment_id: payment.payment_id,
        program_id: payment.program_id,
      })
    }

    console.log(payment.status, payment.type)
  if (payment.status === 'In review Applicant' && payment.type === 'Marketplace') { 
     return ( 
       <Card className="mb-4 w-full">
         <CardContent>
        <div className="flex items-center justify-between w-full flex-wrap ">
            <div className='flex items-center'>
                      <InfoCircleIcon className='text-blue-500 text-2xl mr-2' />
                      <div>
                      <h2 className='font-medium text-gray-800'>
                        Did you recieve the item(s)?
                      </h2>
                      <p className="font-normal text-gray-600 text-sm">
                        If you have received your item(s) and they match the description, please accept the payment. Otherwise, you can reject it decline within 30 days of the purchase.
                      </p>
                        </div>
                    </div>

                    <div className="flex items-center gap-2">
            <Button onClick={handleRecievedItemClick} className="" variant={'outline'}>
                    <CheckCircleIcon className="text-emerald-600 mr-1" />
                    {t('recieved_item')}
                </Button>
              <Dialog open={isRejectDialogOpen} onOpenChange={setIsRejectDialogOpen}>
                <DialogTrigger asChild>
                    <div>
                        <Button className="w-full"  variant={'outline'}>
                        <CloseIcon className="text-red-600 mr-1" />
                        {t('item_not_recieved')}
                        </Button>
                    </div>
        </DialogTrigger>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>{t('decline_payment')}</DialogTitle>
            <DialogDescription>
              {t('provide_rejection_reason')}
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={rejectFormMethods.handleSubmit(handleRejectPayment)}>
            <div className="grid gap-4 py-4">
              <Controller
                control={rejectFormMethods.control}
                name="comment"
                render={({ field, fieldState }) => {
                  return (
                    <div>
                      <Textarea
                        value={field.value}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        id="rejection-reason"
                        placeholder={t('rejection_reason')}
                        className="col-span-2 h-24"
                      />
                      <FormErrorMessage message={fieldState.error?.message} />
                    </div>
                  )
                }}
              />
            </div>
            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => setIsRejectDialogOpen(false)}
              >
                {t('cancel')}
              </Button>
              <SubmitButton
                buttonTxt={t('submit_rejection')}
                status={rejectPayment.status}
              />
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
      </div>
        </div>
         </CardContent>
       </Card>

     )
    }

    return null
      
}